import { useNavigate } from "react-router-dom";
import BlogForm from "./blog-form";
import { titleToSlug } from "../utils/blogUtils";
import Header from "./header";
import Footer from "./footer";

export default function BlogCreate() {
  const navigate = useNavigate();

  const handleSuccess = (blog) => {
    const slug = blog.slug || titleToSlug(blog.title);
    navigate(`/blogs/${slug}`);
  };

  return (
    <main>
      <Header />
      <section className="blog-create-page">
        <div className="blog-create-container">
          <h1 className="blog-create-title">Create New Blog Post</h1>
          <BlogForm onSuccess={handleSuccess} />
        </div>
      </section>
      <Footer />
    </main>
  );
}

